import { AGENT_TYPES as D } from "../../models/agentic/dist/src/AgentType.js";
const T = 2e3, r = (e) => e.toISOString().split(".")[0] + "Z", g = (e) => {
  const t = /* @__PURE__ */ new Date(), n = new Date(t.getTime() - (e + 1) * 24 * 60 * 60 * 1e3);
  return {
    id: `agent-${e + 1}`,
    name: `Conversational Agent ${e + 1}`,
    description: e % 2 === 0 ? `Description for agent ${e + 1}` : "",
    agentType: D.CRGA,
    passageRetrievalModelId: `passage-model-${e % 3 + 1}`,
    answerGenerationModelId: `answer-model-${e % 3 + 1}`,
    numberOfItemsToConsider: e % 2 === 0 ? 50 + e * 5 : void 0,
    followUpEnabled: !0,
    createdDate: r(n),
    modifiedDate: r(t)
  };
}, M = (e, t) => {
  const n = t?.page ?? 0, o = t?.perPage ?? 25, i = Array.from({ length: e }, (d, s) => g(s));
  t?.sortingType && i.sort((d, s) => {
    const f = d[t.sortingType], w = s[t.sortingType], l = String(f ?? "").localeCompare(String(w ?? ""));
    return t.sortingOrder === "DSC" ? -l : l;
  });
  const c = n * o, m = i.slice(c, c + o), p = Math.ceil(e / o);
  return {
    pagination: {
      page: n,
      perPage: o,
      totalItems: e,
      totalPages: p
    },
    items: m
  };
}, y = (e) => {
  const t = r(/* @__PURE__ */ new Date());
  return {
    id: `agent-${Date.now()}`,
    name: e.name,
    description: e.description ?? "",
    agentType: e.agentType,
    passageRetrievalModelId: e.passageRetrievalModelId,
    answerGenerationModelId: e.answerGenerationModelId,
    numberOfItemsToConsider: e.numberOfItemsToConsider,
    followUpEnabled: e.followUpEnabled,
    createdDate: t,
    modifiedDate: t
  };
};
let a = [];
const A = (e = 5) => {
  a = Array.from({ length: e }, (t, n) => g(n));
}, S = (e, t) => {
  const n = a.findIndex((o) => o.id === e);
  return n === -1 ? null : (a[n] = {
    ...a[n],
    ...t,
    modifiedDate: r(/* @__PURE__ */ new Date())
  }, a[n]);
}, u = (e, t = T) => new Promise((n) => {
  setTimeout(() => n(e), t);
});
A(5);
export {
  y as createMockAgentFromRequest,
  g as createMockAgentItem,
  M as createMockAgentListResponse,
  A as initializeMockAgentStore,
  S as updateMockAgent,
  u as withDelay
};
//# sourceMappingURL=AgentConfigurationResource.mocks.js.map
